import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { EconomicGroupEditService } from "../../service/economic-group-edit.service";
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as globalConst from './../../../../constants';

import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/filter';

//Services
import { DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from "../../../shared/alert/alert.component";


@Component({
	selector: 'app-economic-group-edit',
	templateUrl: './economic-group-edit.component.html',
	providers: [
		HttpModule,
		EconomicGroupEditService
	]
})

export class EconomicGroupEditComponent implements OnInit {

	previousPage: string;
	private token;
	private sub: any;
	public permissoes: any[] = [];
	public group: any = {};
	public membersgroup: any = {};
	public membersgroupresult: any[] = [];
	public orderby: string = "DataInicial";
	public sort: string = "asc";
	currentPage: number = 0;
	public isValid: boolean = false;

	private sharedEconomicGroup;
	private individualEconomicGroups;
	//private groupID = "8754d923-abe4-44cb-b547-27dd5ebf4b89";
	private groupID: string = '';

	constructor(private economicGroupEditService: EconomicGroupEditService, fb: FormBuilder, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService, private dialogService: DialogService) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.previousPage = localStorage.getItem('yara.previousPage');
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.sub = this.route.params.subscribe(params => {
			this.groupID = params['guid'];
			this.getGroups(this.groupID);
			this.getMembersGroups(this.groupID);
		}, error => {
			console.log(error);

		});




	}

	getLogs(page, isSearch) {
		if (isSearch) {
			this.orderby = "DataInicial";
			this.sort = "asc";
			this.currentPage = 0;
		}
		// this.orderDetailService.getLogs(this.token, this.Divisao, this.ItemOrdemVendaItem, this.OrdemVendaNumero, this.sort, this.orderby, page).subscribe(result => {
		// 	if (result.Success) {
		// 		this.logs = result.Result;
		// 		this.resultCount = result.Count;
		// 	} else {
		// 		this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
		// 	}
		// }, error => {
		// 	console.log(error);

		// });
	}

	getGroups(groupID) {
		this.economicGroupEditService.getEconomicGroups(groupID).subscribe(result => {

			this.group = {
				UltimaAtualizacao: result.Result[0].UltimaAtualizacao,
				ClassificacaoNome: result.Result[0].ClassificacaoNome,
				ExpTotalGrupo: result.Result[0].ExpTotalGrupo,
				GrupoCodigo: result.Result[0].GrupoCodigo,
				GrupoId: result.Result[0].GrupoId,
				GrupoNome: result.Result[0].GrupoNome,
				LcTotalGrupo: result.Result[0].LcTotalGrupo,
				StatusGrupo: result.Result[0].StatusGrupo,
				TipoRelacao: result.Result[0].TipoRelacao,
				ClassificacaoID: result.Result[0].ClassificacaoID
			}

			if (this.group.StatusGrupo != "AP - Aprovado") {
				this.isValid = true;
			}

		}, error => {
			console.log(error);
		});
	}

	getMembersGroups(groupID) {

		this.membersgroup = {
			GrupoId: groupID
		}

		this.economicGroupEditService.getEconomicGroupsMembers(this.membersgroup).subscribe(result => {
			this.membersgroupresult = result.Result.MembrosDetalhes;
			console.log("this.membersgroupresult:", this.membersgroupresult);
		}, error => {
			console.log(error);
		});
	}

	aprovareprovaMembersGroups(status: boolean) {
		this.economicGroupEditService.getAprovaGroups(this.groupID, status, this.group.ClassificacaoID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
			this.router.navigateByUrl('/cockpit');
		}, error => {
			console.log(error);
		});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getLogs(this.currentPage, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/economic-group/component/economic-group-edit/economic-group-edit.component.ts